import { render, staticRenderFns } from "./FbPostsDialog.vue?vue&type=template&id=84903884&scoped=true&"
import script from "./FbPostsDialog.vue?vue&type=script&lang=js&"
export * from "./FbPostsDialog.vue?vue&type=script&lang=js&"
import style0 from "./FbPostsDialog.vue?vue&type=style&index=0&id=84903884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84903884",
  null
  
)

export default component.exports